export * from './thesis-head'
